import React from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { X } from 'lucide-react';
import { Button } from '../components/ui/button.jsx';

const PaymentCancel = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen mystical-bg py-32 flex items-center justify-center">
      <motion.div
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.5 }}
        className="max-w-2xl w-full mx-4"
      >
        <div className="card-mystical rounded-2xl p-12 text-center">
          <div className="w-16 h-16 rounded-full bg-red-500/20 flex items-center justify-center mx-auto mb-6">
            <X size={32} className="text-red-400" />
          </div>
          <h1 className="text-3xl font-heading text-primary mb-4 uppercase tracking-wider">
            Payment Cancelled
          </h1>
          <p className="text-xl text-primary/70 mb-8">
            Your payment was not completed. No charges have been made to your account.
          </p>
          <p className="text-primary/60 mb-8">
            Ready to try again? The journey awaits.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button
              onClick={() => navigate('/courses/1')}
              className="ornate-button px-8 py-4"
              data-testid="retry-payment-button"
            >
              Try Again
            </Button>
            <Button
              onClick={() => navigate('/')}
              variant="outline"
              className="px-8 py-4"
              data-testid="return-home-button"
            >
              Return Home
            </Button>
          </div>
        </div>
      </motion.div>
    </div>
  );
};

export default PaymentCancel;